<template>
  <div class="ProjectTasksComponent">
    <p v-if="isData&&!selectedLastRevisionRow">{{lang.infotext_3}}</p>
    <div v-if="isData&&selectedLastRevisionRow">
      <span v-if="!isOwner">
        <p>{{lang.infotext_2}}</p>
      </span>
      <span v-if="isOwner">
        <p>{{lang.infotext_1}}:</p>

        <div v-for="item in tasks" :key="item.taskName">

          <div class="list-details">
            <b-list-group>
              <b-list-group-item v-show="isPending">{{lang.label_Name}}: {{lang.task_checkin}}</b-list-group-item>
              <b-list-group-item v-show="!isPending">{{lang.label_Name}}: {{lang.task_checkout}}</b-list-group-item>
              <b-list-group-item>

                <!-- <span v-show="!reserve" class="task-buttons"> -->
                  <b-button v-show="isPending" @click="checkIfPushed" size="sm" id="task_checkIn" variant="success" :disabled="isSpinner"><b-spinner v-show="isSpinner" small></b-spinner> {{lang.button_checkIn}}</b-button>
                  <b-button v-show="!isPending" @click="checkOut" size="sm" id="task_checkOut" variant="warning" :disabled="isSpinner"><b-spinner v-show="isSpinner" small></b-spinner> {{lang.button_checkOut}}</b-button>
                <!-- </span> -->

                <!-- <span v-show="reserve" class="task-buttons">
                  <b-button v-show="!isPending" @click="checkIn" size="sm" id="task_checkIn" variant="success">
                    e{{lang.button_checkIn}}</b-button>
                  <b-button v-show="isPending" @click="checkOut" size="sm" id="task_checkOut" variant="warning">
                    f{{lang.button_checkOut}}</b-button>
                </span> -->

              </b-list-group-item>



            </b-list-group>
          </div>


          <!-- <span v-show="!reserve" class="task-buttons">
              <b-button v-show="isPending" @click="checkIn" size="sm" id="task_checkIn" variant="success">{{lang.button_checkIn}}</b-button>
              <b-button v-show="!isPending" @click="checkOut" size="sm" id="task_checkOut" variant="warning">{{lang.button_checkOut}}</b-button>
              </span>

              <span v-show="reserve" class="task-buttons">
              <b-button v-show="!isPending" @click="checkIn" size="sm" id="task_checkIn" variant="success">{{lang.button_checkIn}}</b-button>
              <b-button v-show="isPending" @click="checkOut" size="sm" id="task_checkOut" variant="warning">{{lang.button_checkOut}}</b-button>
              </span> -->




        </div>
      </span>

    </div>


    <span v-if="!isData">
      <p>{{lang.infotext_2}}</p>
    </span>



  </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"

  export default {
      name: "ProjectTasksComponent",
      props:{
        lang: Object,
        parent: String
      },
      components: {
        
        LoaderComponent
      },
      data () {
        return {
          name: "ProjectTasksComponent",
          tasks: [],
          reserve: false,
          isSpinner: false,
        }
      },
      computed: {

        isPending() {
          
          if (this.lastRevisionHistory == undefined) {
            return
          }

          //return this.$store.getters.selectedRows[0].col___status.value.display == "pending";
          return this.lastRevisionHistory.status.display == "pending";
          // let tab = this.$store.getters.revisionHistory;
          // let obj = tab[0];
          // for (let i = 0, lei = tab.length; i < lei; i++) {

          //   if (tab[i].revision > obj.revision) {
          //     obj = tab[i];
          //   }
          // }
          // if (obj.status.display == "pending") {
          //   return true;
          // } else {
          //   return true;
          // }
            
        },
        lastRevisionHistory() {
          if (this.$store.getters.revisionHistory == null) {
            return
          }
          let tab = this.$store.getters.revisionHistory;
          let obj = tab[0];
          for (let i = 0, lei = tab.length; i < lei; i++) {

            if (tab[i].revision > obj.revision) {
              obj = tab[i];
            }
          }

          return obj;
        },
        isOwner(){
          // if (this.lastRevisionHistory == undefined) {
          //   return false;
          // }


          // if (this.lastRevisionHistory.userId == this.$store.getters.currentUser.userId && this.lastRevisionHistory.status.display == "pending") {
          //   return true;
          // }
          // return false;
          if (this.isPending == false){
            return true;
          }
          return this.lastRevisionHistory.userId == this.$store.getters.currentUser.userId;
          // if (this.$store.getters.selectedRows.length == 0){
          //   return false;
          // }
          // return this.$store.getters.selectedRows[0].col___revisionId.userId == this.$store.getters.currentUser.userId;
        },
        revisionId(){
          let revisionId = "";
          if (this.parent == "details"){
            const tab = this.$store.getters.selectedRevisionRow
            let rev = 0;
            let revId = "";
            for (let i = 0, lei = tab.length; i < lei; i++){
              
              if (tab[i].revision > rev){
                rev = tab[i].revision;
                revId = tab[i].revisionId;
              }
              
            }


            revisionId = revId;
          }else{
            if (this.$store.getters.selectedRows.length != 0){
              revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
                          
            }
          }
          
          return revisionId;

        },
        lastRevisionHistory(){
      
          let tab = this.$store.getters.revisionHistory;
          let obj = tab[0];
          for (let i = 0, lei = tab.length; i < lei; i++){
            
            if (tab[i].revision > obj.revision){
              obj = tab[i];
            }
          }
          
          return obj;
        },
        selectedLastRevisionRow(){
          if (this.$store.getters.selectedRevisionRow.length == 0){
            return false;
          }
          return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
        },
        isData(){

          return this.tasks.length != 0

        },
        reloadedAfterAction(){
            return this.$store.getters.reloadedAfterAction;
        },
      },
      created () {
        
        
        this.getTasks();


      },
      watch: {
        revisionId: function (newVal, oldVal) {
          
          
          this.getTasks();


        },
        reloadedAfterAction: function(newValue, oldValue){

          
          if (newValue.name == this.name){
            
              if (newValue.status == true){
                  
                  this.getTasks();
                  
                  newValue.status = false;
                  newValue.name = "";
                  this.$store.dispatch("reloadAfterAction", newValue);
              }
          }
            
        }
      },
      updated() {
                


      },
      methods: {

        getTasks(){

            
            this.tasks = {
                taskName: ""
            }  
          
        
        },
        checkIfPushed() {
          let vue = this;

          let funcYes = function () {

            vue.checkIn();
          }

          const obj = {
              title: vue.lang.alert_title_checkIfPushed,
              text: vue.lang.alert_warning_checkIfPushed,
              type: "sure",
              buttons: 2,
              size: "lm",
              funcYes: funcYes,
              funcNo: "",

            }
    
            vue.$store.dispatch("showAlert", obj);

        },
        checkIn() {
          console.log("checkIn")
          this.isSpinner = true;
            let vue = this;

            let funcYes = function(_vue){

              const obj = {
                projectRevisionId: vue.revisionId,
                comment: vue.$store.getters.eventTaskForm.reason
              }

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_checkIn", obj)
              .then((result) => {
                console.log(result)
                
                  vue.isSpinner = false;
                  if (result.status == "OK"){
                      if (result.data == 1){
                        
                        vue.reserve = !vue.reserve;

                          let obj = {
                              text: vue.lang.alert_success_checkIn,
                              time: 10,
                              type: "success"
                          }

                          vue.$store.dispatch("displayFooterAlert", obj);


                          if(vue.parent != "details"){
                          
                              const reloadObj = {
                                status: true,
                                name: "DataTableFilteredOnApiProjComponent"
                              }
                              vue.$store.dispatch("reloadAfterAction", reloadObj);
                          }else{
                            
                              const reloadObj = {
                                status: true,
                                name: "ProjectRevisionHistoryComponent"
                              }
                              vue.$store.dispatch("reloadAfterAction", reloadObj);
                              
                              
                          }
                                                

                          
                      }else{

                          let obj = {
                              text: vue.lang.alert_error_checkIn + ".",
                              time: 15,
                              type: "danger"
                          }

                          vue.$store.dispatch("displayFooterAlert", obj);

                      }
                  }else{
                      let obj = {
                        text: vue.lang.alert_error_checkIn + ": " + result.message,
                          time: 15,
                          type: "danger"
                      }

                      vue.$store.dispatch("displayFooterAlert", obj);
                  }
                  

              })


            }

            const obj = {
              
              text: "",
              type: "eventtaskform",
              buttons: 2,
              size: "md",
              lang: vue.lang.modal_Comment,
              data: {
                changeRevisionOfDependentPartsVisible: false,
                indicatedUserIdVisible: false,
                reasonVisible: true,
                isSecondLevel: vue.isSecondLevel
              },
              funcNo: "",
              funcYes: funcYes,
              
            };
            
            this.$store.dispatch("showModalComponent", obj);
            


        },
        checkOut(){
          this.isSpinner = true;
            let vue = this;

            const obj = {
                projectRevisionId: vue.revisionId
            }

             vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_checkOut", obj)
            .then((result) => {
              if (result.status == "OK") {
                  
                console.log(result)
                    vue.isSpinner = false;
                    if (result.data == 1){

                      vue.reserve = !vue.reserve;

                        let obj = {
                            text: vue.lang.alert_success_checkOut,
                            time: 10,
                            type: "success"
                        }

                        vue.$store.dispatch("displayFooterAlert", obj);


                        if(vue.parent != "details"){
                        
                            const reloadObj = {
                            status: true,
                            name: "DataTableFilteredOnApiProjComponent"
                            }
                            vue.$store.dispatch("reloadAfterAction", reloadObj);
                        }else{
                            const reloadObj = {
                            status: true,
                            name: "ProjectRevisionHistoryComponent"
                            }
                            vue.$store.dispatch("reloadAfterAction", reloadObj);
                        }
                    }else{

                        let obj = {
                            text: vue.lang.alert_error_checkOut,
                            time: 15,
                            type: "danger"
                        }

                        vue.$store.dispatch("displayFooterAlert", obj);

                    }
                }else{
                    let obj = {
                        text: vue.lang.alert_error_checkOut,
                        time: 15,
                        type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);
                }

            })

        },
        

      }


  }
</script>
<style lang="scss">
.ProjectTasksComponent {
  .task-buttons{
    margin-left: 50px;
  }
  .task-reason-text{
    margin-left: 20px;
  }
  .list-group-item{
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ProjectTasksComponent.vue